import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button,
  Divider,
  Card,
  CardContent
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const ChronicleBeginning = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/chronicles')}
        sx={{ mb: 3 }}
      >
        Zurück zur Chronik
      </Button>

      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#E30613' }}>
          Die Anfänge von DB Regio Bus Mitte
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          1994-2000: Gründung und erste Jahre
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Mit der deutschen Bahnreform von 1994 begann ein neues Kapitel in der Geschichte 
          des öffentlichen Nahverkehrs. Die Deutsche Bundesbahn wurde aufgeteilt und regionalisiert, 
          was zur Entstehung von DB Regio führte - und damit auch zur Gründung von DB Regio Bus Mitte.
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          DB Regio Bus Mitte entstand als Teil der neu strukturierten Deutschen Bahn AG mit dem Ziel, 
          den regionalen Busverkehr in der Region Frankfurt am Main und Umgebung zu betreiben. 
          Das Unternehmen übernahm zunächst die bestehenden Buslinien der ehemaligen Bundesbahn 
          und entwickelte sie weiter.
        </Typography>

        <Card sx={{ my: 3, backgroundColor: '#f5f5f5' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="primary">
              Die ersten Herausforderungen
            </Typography>
            <Typography variant="body1">
              • Übernahme und Integration bestehender Buslinien<br />
              • Aufbau einer eigenständigen Verwaltungsstruktur<br />
              • Modernisierung der Fahrzeugflotte<br />
              • Etablierung als zuverlässiger ÖPNV-Partner in der Region
            </Typography>
          </CardContent>
        </Card>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          In den ersten Jahren konzentrierte sich DB Regio Bus Mitte darauf, die übernommenen 
          Buslinien zu stabilisieren und auszubauen. Besonders wichtig war die Verbindung 
          zwischen den S-Bahn-Stationen und den umliegenden Gemeinden, wodurch ein integriertes 
          Verkehrssystem geschaffen wurde.
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Die strategische Lage in der Region Frankfurt am Main bot von Anfang an große Chancen. 
          Als wichtiger Wirtschaftsstandort mit kontinuierlichem Wachstum stieg auch die Nachfrage 
          nach öffentlichen Verkehrsverbindungen stetig an.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Card sx={{ backgroundColor: '#e3f2fd' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Quellen:
            </Typography>
            <Typography variant="body2" component="div">
              • Deutsche Bahn AG: "Geschichte der Bahnreform" - Unternehmensarchiv<br />
              • Bundesministerium für Verkehr: "20 Jahre Bahnreform" (2014)<br />
              • VDV (Verband Deutscher Verkehrsunternehmen): Chronik des ÖPNV<br />
              • Lokale Zeitungsarchive der Frankfurter Rundschau (1994-2000)
            </Typography>
          </CardContent>
        </Card>
      </Paper>
    </Container>
  );
};

export default ChronicleBeginning;